// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `
.aboutAxis_header_text {
    text-align: center;
    font-size: 50px;
    color: #000;
    font-weight: medium;
    margin-top: 168px;
}

.image_about {
    width: 559px;
    height: 442px;
    vertical-align: middle;

    margin-top: -1330px;
    margin-left: 270px;
    margin-right: 270px;
    position: absolute;
}
/* .TopSlide{
    height:420px ;
} */
.right-img{
    width: 100%;
    height: 420px;
    margin-top: 20px;
    margin-bottom: 20px;
}

.cover-img-container {
    height: 500px;
    width: 100%;
    overflow: hidden;
}

.cover-img-container img {
    width: 100%;
}

.boder_area {
    position: relative;
    /*  border: 1px solid #000;*/
    display: flex;
    flex-direction: column;
    align-items: center;
    height: 100%;
}

.about-img {
    display: flex;
    margin-top: -140px;
    margin-bottom: -100px;
}

.text_inside_border {
    font-size: 20px;
    color: grey;
    font-weight: medium;
    line-height: 30px;
    padding-bottom: 30px;
    /* padding-top: 140px; */
}

/* .first_letter_text {
    font-size: 45px;
    font-weight: bold;
} */

.container-wrapper .card-title::before {
    content: "";
    border-left: 5px solid #ff5800;
    padding-left: 10px;
}

.container-wrapper .card-title{
    font-size: 34px;
    color: #000;
    font-weight: 500;
    margin-top: 20px
}

.about-page-market{
    float: right !important;
    }


.card{
    position: relative;
    display: flex;
    flex-direction: column;
    min-width: 0;
    word-wrap: break-word;
    background-color: #fff;
    background-clip: border-box;
    border: 1px solid rgba(0, 0, 0, 0.125);
    border-radius: 0.25rem;
}

.container-wrapper .card-text {
    font-size: 22px;
    font-weight: 300;
    color: #000;
} 

.back_home_link {
    font-size: 13px;
    padding-left: 10px;
    float: left;
    padding-bottom: 12px;
}

.form {
    margin-top: 50px;
}

.about-image-box {
    display: flex;
    justify-content: center;
    
}

.container-wr{
    margin-top: 0 !important;
}
@media (max-width: 575.98px) { 
    .right-img {
        margin-top: 0;
    }
}

`, "",{"version":3,"sources":["webpack://./src/assets/styles/css/pages/about/about.css"],"names":[],"mappings":";AACA;IACI,kBAAkB;IAClB,eAAe;IACf,WAAW;IACX,mBAAmB;IACnB,iBAAiB;AACrB;;AAEA;IACI,YAAY;IACZ,aAAa;IACb,sBAAsB;;IAEtB,mBAAmB;IACnB,kBAAkB;IAClB,mBAAmB;IACnB,kBAAkB;AACtB;AACA;;GAEG;AACH;IACI,WAAW;IACX,aAAa;IACb,gBAAgB;IAChB,mBAAmB;AACvB;;AAEA;IACI,aAAa;IACb,WAAW;IACX,gBAAgB;AACpB;;AAEA;IACI,WAAW;AACf;;AAEA;IACI,kBAAkB;IAClB,4BAA4B;IAC5B,aAAa;IACb,sBAAsB;IACtB,mBAAmB;IACnB,YAAY;AAChB;;AAEA;IACI,aAAa;IACb,kBAAkB;IAClB,qBAAqB;AACzB;;AAEA;IACI,eAAe;IACf,WAAW;IACX,mBAAmB;IACnB,iBAAiB;IACjB,oBAAoB;IACpB,wBAAwB;AAC5B;;AAEA;;;GAGG;;AAEH;IACI,WAAW;IACX,8BAA8B;IAC9B,kBAAkB;AACtB;;AAEA;IACI,eAAe;IACf,WAAW;IACX,gBAAgB;IAChB;AACJ;;AAEA;IACI,uBAAuB;IACvB;;;AAGJ;IACI,kBAAkB;IAClB,aAAa;IACb,sBAAsB;IACtB,YAAY;IACZ,qBAAqB;IACrB,sBAAsB;IACtB,2BAA2B;IAC3B,sCAAsC;IACtC,sBAAsB;AAC1B;;AAEA;IACI,eAAe;IACf,gBAAgB;IAChB,WAAW;AACf;;AAEA;IACI,eAAe;IACf,kBAAkB;IAClB,WAAW;IACX,oBAAoB;AACxB;;AAEA;IACI,gBAAgB;AACpB;;AAEA;IACI,aAAa;IACb,uBAAuB;;AAE3B;;AAEA;IACI,wBAAwB;AAC5B;AACA;IACI;QACI,aAAa;IACjB;AACJ","sourcesContent":["\n.aboutAxis_header_text {\n    text-align: center;\n    font-size: 50px;\n    color: #000;\n    font-weight: medium;\n    margin-top: 168px;\n}\n\n.image_about {\n    width: 559px;\n    height: 442px;\n    vertical-align: middle;\n\n    margin-top: -1330px;\n    margin-left: 270px;\n    margin-right: 270px;\n    position: absolute;\n}\n/* .TopSlide{\n    height:420px ;\n} */\n.right-img{\n    width: 100%;\n    height: 420px;\n    margin-top: 20px;\n    margin-bottom: 20px;\n}\n\n.cover-img-container {\n    height: 500px;\n    width: 100%;\n    overflow: hidden;\n}\n\n.cover-img-container img {\n    width: 100%;\n}\n\n.boder_area {\n    position: relative;\n    /*  border: 1px solid #000;*/\n    display: flex;\n    flex-direction: column;\n    align-items: center;\n    height: 100%;\n}\n\n.about-img {\n    display: flex;\n    margin-top: -140px;\n    margin-bottom: -100px;\n}\n\n.text_inside_border {\n    font-size: 20px;\n    color: grey;\n    font-weight: medium;\n    line-height: 30px;\n    padding-bottom: 30px;\n    /* padding-top: 140px; */\n}\n\n/* .first_letter_text {\n    font-size: 45px;\n    font-weight: bold;\n} */\n\n.container-wrapper .card-title::before {\n    content: \"\";\n    border-left: 5px solid #ff5800;\n    padding-left: 10px;\n}\n\n.container-wrapper .card-title{\n    font-size: 34px;\n    color: #000;\n    font-weight: 500;\n    margin-top: 20px\n}\n\n.about-page-market{\n    float: right !important;\n    }\n\n\n.card{\n    position: relative;\n    display: flex;\n    flex-direction: column;\n    min-width: 0;\n    word-wrap: break-word;\n    background-color: #fff;\n    background-clip: border-box;\n    border: 1px solid rgba(0, 0, 0, 0.125);\n    border-radius: 0.25rem;\n}\n\n.container-wrapper .card-text {\n    font-size: 22px;\n    font-weight: 300;\n    color: #000;\n} \n\n.back_home_link {\n    font-size: 13px;\n    padding-left: 10px;\n    float: left;\n    padding-bottom: 12px;\n}\n\n.form {\n    margin-top: 50px;\n}\n\n.about-image-box {\n    display: flex;\n    justify-content: center;\n    \n}\n\n.container-wr{\n    margin-top: 0 !important;\n}\n@media (max-width: 575.98px) { \n    .right-img {\n        margin-top: 0;\n    }\n}\n\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
